import React, { useState } from 'react';
import css from 'src/components/Tooltip/Tooltip.scss';
import Portal from 'src/components/Tooltip/Portal';
import * as PropTypes from 'prop-types';
import { Flexbox } from 'cw-ui-core';
import cx from 'classnames';

const POSITIONS = { TOP: 'top', BOTTOM: 'bottom', LEFT: 'left', RIGHT: 'right' };

const Tooltip = ({ children, className, toolTipContent }) => {
    const [isHover, setIsHover] = useState(false);
    const [verticalPosition, setVerticalPosition] = useState('');
    const [horizonatlPosition, setHorizontalPosition] = useState('right');
    const [coords, setCoords] = useState();

    const handleOnMouseOver = e => {
        if (e.currentTarget) {
            const rect = e.currentTarget.getBoundingClientRect();
            const docWidth = document.documentElement.clientWidth;
            const docHeight = document.documentElement.clientHeight;

            if (rect.x <= 0.65 * docWidth && rect.y <= 0.65 * docHeight) {
                setCoords({
                    left: rect.x + rect.width / 2 - 20,
                    top: rect.y + rect.height,
                });
                setVerticalPosition(POSITIONS.BOTTOM);
                setHorizontalPosition(POSITIONS.RIGHT);
            } else if (rect.x >= 0.65 * docWidth && rect.y <= 0.65 * docHeight) {
                setCoords({
                    right: docWidth - rect.left - rect.width / 2 - 20,
                    top: rect.y + rect.height,
                });
                setVerticalPosition(POSITIONS.BOTTOM);
                setHorizontalPosition(POSITIONS.LEFT);
            } else if (rect.x <= 0.65 * docWidth && rect.y >= 0.65 * docHeight) {
                setCoords({
                    left: rect.x + rect.width / 2 - 20,
                    bottom: docHeight - rect.top,
                });
                setVerticalPosition(POSITIONS.TOP);
                setHorizontalPosition(POSITIONS.RIGHT);
            } else if (rect.x >= 0.65 * docWidth && rect.y >= 0.65 * docHeight) {
                setCoords({
                    right: docWidth - rect.left - rect.width / 2 - 20,
                    bottom: docHeight - rect.top,
                });
                setVerticalPosition(POSITIONS.TOP);
                setHorizontalPosition(POSITIONS.LEFT);
            }
        }
        setIsHover(true);
    };
    return (
        <div
            className={css.outerContainer}
            onMouseEnter={e => handleOnMouseOver(e)}
            onMouseLeave={() => setIsHover(false)}
            onFocus={e => handleOnMouseOver(e)}
            onBlur={() => setIsHover(false)}>
            {children}
            {isHover && coords && (
                <Portal>
                    <Flexbox
                        className={cx(
                            css.container,
                            className,
                            verticalPosition === POSITIONS.TOP ? css.top : css.bottom,
                            horizonatlPosition === POSITIONS.LEFT ? css.left : css.right
                        )}
                        style={{ ...coords }}
                        column>
                        <div className={css.toolTipContent}>{toolTipContent}</div>
                    </Flexbox>
                </Portal>
            )}
        </div>
    );
};

Tooltip.propTypes = {
    toolTipContent: PropTypes.oneOfType([PropTypes.elementType, PropTypes.element]),
    className: PropTypes.string,
};
Tooltip.defaultProps = {
    toolTipContent: {},
    className: '',
};

export default Tooltip;
